var _rect, _rect2, _path, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCategory7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 23,
    rx: 3.5,
    fill: "#eb672d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 23,
    rx: 3.5,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.602 16H17.394L13.726 6.662H11.682L8.014 16H9.806L10.492 14.208H14.916L15.602 16ZM12.704 8.048L14.454 12.766H10.954L12.704 8.048ZM17.9519 12.612C17.9519 14.67 19.3939 16.168 21.4519 16.168C22.7679 16.168 23.5659 15.608 24.0419 14.964L23.0759 14.068C22.6979 14.586 22.1799 14.866 21.5219 14.866C20.2899 14.866 19.4779 13.928 19.4779 12.612C19.4779 11.296 20.2899 10.372 21.5219 10.372C22.1799 10.372 22.6979 10.638 23.0759 11.17L24.0419 10.274C23.5659 9.63 22.7679 9.07 21.4519 9.07C19.3939 9.07 17.9519 10.568 17.9519 12.612ZM27.3609 16.168C28.0469 16.168 28.4809 15.986 28.7469 15.734L28.3969 14.628C28.2849 14.754 28.0189 14.866 27.7389 14.866C27.3189 14.866 27.0949 14.53 27.0949 14.068V10.526H28.4669V9.238H27.0949V7.39H25.6249V9.238H24.5049V10.526H25.6249V14.432C25.6249 15.552 26.2269 16.168 27.3609 16.168ZM30.5296 8.202C31.0336 8.202 31.4396 7.796 31.4396 7.292C31.4396 6.788 31.0336 6.382 30.5296 6.382C30.0396 6.382 29.6196 6.788 29.6196 7.292C29.6196 7.796 30.0396 8.202 30.5296 8.202ZM29.8016 16H31.2716V9.238H29.8016V16ZM34.9566 16H36.5386L39.2966 9.238H37.7146L35.7406 14.306L33.7666 9.238H32.1986L34.9566 16ZM39.7996 12.612C39.7996 14.754 41.3116 16.168 43.3416 16.168C44.4196 16.168 45.4136 15.832 46.0856 15.188L45.4136 14.222C44.9376 14.698 44.1536 14.964 43.4956 14.964C42.2216 14.964 41.4516 14.124 41.3396 13.102H46.5616V12.752C46.5616 10.624 45.2596 9.07 43.2296 9.07C41.2276 9.07 39.7996 10.652 39.7996 12.612ZM43.2296 10.274C44.5596 10.274 45.1056 11.268 45.1336 12.066H41.3256C41.3956 11.24 41.9696 10.274 43.2296 10.274Z",
    fill: "#eb672d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 23,
    rx: 3.5,
    stroke: "#eb672d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 23,
    rx: 3.5,
    stroke: "white",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategory7);
export default __webpack_public_path__ + "static/media/iconCategory7.8a5674f6939b1dcc502e25f18be9ddd2.svg";
export { ForwardRef as ReactComponent };